const noFollowUrls = ['https://www.testhq.com/store']

module.exports = { noFollowUrls }
